/* eslint-disable react/no-unknown-property */
import React, { FC, useEffect, useMemo, useState } from 'react';

// eslint-disable-next-line import/no-extraneous-dependencies
import { Helmet as HelmetBase } from 'react-helmet';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Helmet = HelmetBase as any;

import Navbar from '../../components/Navbar';
import HeaderHome from '../../components/HeaderHome';
import WhyHome from '../../components/WhyHome';
import Guide from '../../components/Guide';
import ReadytoGetStarted from '../../components/ReadytoGetStarted';
import Footer from '../../components/Footer';
import InterlinkSection from '../../components/InterlinkSection';
import { useMPCWidget } from '../../helpers/useMPCWidget';
import {
  cryptoData,
  cryptoSectionTranslations,
  getCryptoUrl,
} from '../../data/cryptoData';

interface Props {
  data?: Queries.HomePageQuery;
  locale?: string;
  provider?: string;
  showLoginWidget?: boolean;
}

const Home: FC<Props> = ({ data, locale, provider, showLoginWidget }) => {
  const { file } = data || {};
  const [hasScrolled, setHasScrolled] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const { hasAccount, isLoading, user } = useMPCWidget();

  const localeKey = (locale as 'en' | 'es' | 'ru' | 'zh') || 'en';
  const cryptoLinkPrefix =
    cryptoSectionTranslations.linkPrefix[localeKey] || 'Sell';

  const cryptoLinks = useMemo(
    () =>
      cryptoData.map(crypto => ({
        slug: crypto.slug,
        label: `${cryptoLinkPrefix} ${crypto.names[localeKey] || crypto.names.en}`,
        url: getCryptoUrl(crypto.slug, locale || 'en'),
      })),
    [locale, localeKey, cryptoLinkPrefix]
  );

  useEffect(() => {
    const handleScroll = () => {
      if (!hasScrolled) {
        setHasScrolled(true);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [hasScrolled]);

  useEffect(() => {
    const handleLoad = () => {
      setTimeout(() => {
        setShowVideo(true);
      }, 2000);
    };

    if (document.readyState === 'complete') {
      handleLoad();
    } else {
      window.addEventListener('load', handleLoad);
    }

    return () => {
      window.removeEventListener('load', handleLoad);
    };
  }, []);

  return (
    <>
      <Helmet>
        <link
          rel="preconnect"
          href="https://fonts.bitcoin.com/Elza/Elza_Condensed_Black/crossmedia/Elza-CondensedBlack.woff"
          as="font"
          type="font/woff"
          crossOrigin="anonymous"
          fetchPriority="high"
        />
        <link
          rel="preconnect"
          href="https://fonts.bitcoin.com/Satoshi_Variable/Fonts/WEB/fonts/Satoshi-Medium.woff"
          as="font"
          type="font/woff"
          crossOrigin="anonymous"
          fetchPriority="high"
        />
        <link
          rel="preconnect"
          href="https://fonts.bitcoin.com/Chivo_Mono/ChivoMono-VariableFont_wght.ttf"
          as="font"
          type="font/ttf"
          crossOrigin="anonymous"
        />

        <style>
          {`
            @font-face {
              font-family: 'Elza Condensed';
              src: url('https://fonts.bitcoin.com/Elza/Elza_Condensed_Black/crossmedia/Elza-CondensedBlack.woff') format('woff');
              font-style: normal;
              font-display: swap;
            }
            @font-face {
              font-family: 'Satoshi Variable Medium';
              src: url('https://fonts.bitcoin.com/Satoshi_Variable/Fonts/WEB/fonts/Satoshi-Medium.woff') format('woff');
              font-weight: normal;
              font-style: normal;
              font-display: swap;
            }
            @font-face {
              font-family: 'Chivo Mono';
              src: url('https://fonts.bitcoin.com/Chivo_Mono/ChivoMono-VariableFont_wght.ttf') format('truetype');
              font-weight: normal;
              font-style: normal;
              font-display: swap;
            }
          `}
        </style>
        <script
          src={
            process.env.MPC_WIDGET_URL ||
            'https://widget.bitcoin.com/widget.v0.7.14.iife.js'
          }
          type="text/javascript"
        />
      </Helmet>
      <Navbar navbar={file?.childJson?.navbar || null} locale={locale || ''} />
      <main>
        <HeaderHome
          headerHome={file?.childJson?.headerHome || null}
          provider={provider}
          showLoginWidget={showLoginWidget}
          isLoading={isLoading}
          hasAccount={hasAccount}
          user={user}
          showVideo={showVideo}
        />
        <WhyHome
          whyHome={file?.childJson?.whyHome || null}
          // hasScrolled={hasScrolled}
        />
        <InterlinkSection
          title={
            cryptoSectionTranslations.homepage.title[localeKey] ||
            'Sell 120+ cryptocurrencies'
          }
          subtitle={
            cryptoSectionTranslations.homepage.subtitle[localeKey] ||
            'Securely sell and manage a wide range of cryptocurrencies with ease.'
          }
          items={cryptoLinks}
          showSeeMore
          seeMoreLabel={
            cryptoSectionTranslations.homepage.seeMore[localeKey] || 'See more'
          }
        />
        <Guide
          guide={file?.childJson?.guide || null}
          hasScrolled={hasScrolled}
          showVideo={showVideo}
        />
        <ReadytoGetStarted
          readytogetstarted={file?.childJson?.readytogetstarted || null}
          // hasScrolled={hasScrolled}
        />
      </main>
      <Footer
        footer={file?.childJson?.footer || null}
        // hasScrolled={hasScrolled}
      />
    </>
  );
};

export default Home;
